export enum ImportDetailTabs {
    Imported = 'imported',
    Publishing = 'publishing',
    Published = 'published',
    Failed = 'failed',
    Warning = 'warning',
}
